import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'messageTime',
    standalone: false,
    pure: true
})
export class MessageTimePipe implements PipeTransform {
  transform(timestamp: string): string {
    if (!timestamp) {return '';}
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();
    const timeStr = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    if (isToday) {return timeStr;}
    if (isYesterday) {return `Yesterday ${timeStr}`;}
    return `${date.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${timeStr}`;
  }
}
